import { Theme } from '@mui/material';

export const burgerMenuV2Styles = (theme: Theme) => ({
	root: {
		display: 'flex',
		backgroundColor: 'white',
		flexDirection: 'column',
		minHeight: '100vh',
	},
	loader: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		zIndex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'rgba(0, 0, 0, 0.5)'
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		p: '16px',

		borderTop: '2px solid black',
		borderBottom: '2px solid black',
	},
	closeButton: {
		color: 'black',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		pt: '40px',
		px: '16px',
	},
	navLink: {
		fontFamily: 'Integral CF',
		lineHeight: '1.2em',
		cursor: 'pointer',
	},
});
export const burgerMenuV3Styles = (theme: Theme) => ({
	root: {
		display: 'flex',
		backgroundColor: '#000000',
		flexDirection: 'column',
		minHeight: '100%',
	},
	loader: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		zIndex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'rgba(0, 0, 0, 0.5)'
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		p: '16px',

		borderTop: '2px solid #FFFFFF',
		borderBottom: '2px solid #FFFFFF',
	},
	closeButton: {
		color: '#FFFFFF',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		pt: '40px',
		px: '16px',
	},
	navLink: {
		fontFamily: 'Integral CF',
		lineHeight: '1.2em',
		cursor: 'pointer',
		color: '#FFFFFF',
	},
});
